import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  styleOverrides: {
    root: {
      overflow: 'visible',
      flexShrink: '0',
    },
    colorAction: ({ theme }) => ({
      color: theme.palette.onSurface.os900,
    }),
    colorDisabled: ({ theme }) => ({
      color: theme.palette.disabled.primary,
    }),
    colorPrimary: ({ theme }) => ({
      color: theme.palette.brand.primary,
    }),
    colorSecondary: ({ theme }) => ({
      color: theme.palette.brand.secondary,
    }),
    colorError: ({ theme }) => ({
      color: theme.palette.error.main,
    }),
  },
  variants: [
    {
      // custom size
      props: { fontSize: 'extraSmall' },
      style: {
        fontSize: '16px',
      },
    },
    {
      // custom size
      props: { fontSize: 'extraLarge' },
      style: {
        fontSize: '40px',
      },
    },
    // sizes from @mui, changed from rem to px
    {
      props: { fontSize: 'small' },
      style: { fontSize: '20px' },
    },
    {
      props: { fontSize: 'medium' },
      style: { fontSize: '24px' },
    },
    {
      props: { fontSize: 'large' },
      style: { fontSize: '35px' },
    },
    // custom colors types
    {
      props: { color: 'info' },
      style: ({ theme }) => ({
        color: theme.palette.info['main'],
      }),
    },
    {
      props: { color: 'success' },
      style: ({ theme }) => ({
        color: theme.palette.success['main'],
      }),
    },
    {
      props: { color: 'warning' },
      style: ({ theme }) => ({
        color: theme.palette.warning['main'],
      }),
    },
  ],
};
